module.exports = __webpack_public_path__ + "static/img/loginbg.31c40c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginbg.jpg
// module id = v8LK
// module chunks = 1